
const Strings = {
    paymentExpriryTime:60 * 15,
    groupId:{    

        midnight:"midnight",
        morning:"morning",
        afternoon:"afternoon",
        evening:"evening"
    },
    //TODO: dummy values. update the value before adding apis and states
    logoUrl: "https://media.bookyourzone.com/logo-transparent.png",
    routerPath: {
        login: "/login"
    },
    groundConfigRadio:{
        shared:"shared",
        independent:"independent"
    },
    groundUsage:{
        full:"FULL",
        half:"HALF",
        QUARTER:"QUARTER"
    },
    // Day and night rates split at 6am/6pm. Shown next to every rate field so a
    // vendor does not have to guess which hours each one covers.
    pricingHours:{
        day:"6am - 6pm",
        night:"6pm - 6am"
    },

    ToastTypes: {
        isErrorToast: true,
        isSuccessToast: true
    },
    LoginStrings: {
        session_expired: ""
    },
    LoginType: { GoogleOAuthSSO: "GoogleOAuthSSO", GoogleOneTapSSO: "GoogleOneTapSSO", Email: "Email", Phone: "Phone" },
    bookingstatus: { pending: "pending", confirmed: "confirmed", cancelled: "cancelled", failed: "failed", completed: "completed" ,booked:"booked",hold:"hold",unavailable:"unavailable"},
    paymentStatus: { pending: "pending", confirmed: "confirmed", cancelled: "cancelled", failed: "failed" },
    slotStatus: {
        available: "available", hold: "hold", booked: "booked", unavailable: "unavailable"
    },
    btnText: {
        paynow: "Pay Now",
        cancel: "Cancel",
        procced: "Proceed",
        slot_reserve_text: "This slot is temporarily reserved for you, pay within 10 minutes to confirm.",
        resendotp: "Resend OTP",
        verifyotp: "Verify OTP"

    },
    staticConfigKeys: {
        sportsTypes: "sportsTypes",
        amenities: "amenities",
        banks:"banks"

    },
    ImgType: {
        venuethumbnail: "venue-thumbnail",
        courtsImages: "courts-images"

    }


};

export default Strings;
